<template>
  <div id="berandalaporan">
     <section>
       <p>Catatan</p>
       <p>1.Pastikan File Anda xls/xlxs</p>
       <p>2.Pastikan Data yang anda Import tidak terdapat isi bentuk rumus</p>
       <p>3.Hapus Kolom Note atau komentar yang terdapat pada file excel</p>
       <p>4.Sebelum Import File,tambah data Biro terlebih dahulu</p>
       <br>
       <b-field>
        <b-upload v-model="file" @input="readImage"  accept=".xls,.xlsx" drag-drop v-if="upload">
          <section class="section">
            <div class="content has-text-centered">
              <p v-if="upload">
                <b-icon icon="upload" size="is-medium">
                </b-icon>
              </p>
              <p v-if="upload">
                Choose your files here and click to upload
              </p>
            </div>
          </section>
        </b-upload>
      </b-field>
      <div class="tags">
        <span class="tag is-primary" v-if="preview">
          {{file.name}}
          <button
            class="delete is-small"
            type="button"
            @click="deleteDropFile()"
          ></button>
        </span>
      </div>
       <br />
        <b-button rounded class="button is-primary" @click="postData()">
          Simpan
        </b-button>
    </section>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false">
    </b-loading>
  </div>
</template>

<script>
export default { 
  data() {
    return {
        activeTab: 0,
        isLoading: false,
        file:null,
        imports:[],
        snackbarMsg: '',
       // checkboxGroup: [],
        upload: true,
        preview: false,
        dataImpor:new FormData(),
        config: {}
        // form:{
        //   file:{
        //     value:'', type:'', message:''},
        // }
    }
  },
  methods:
  {
    readImage(){
      
      this.upload = false
      this.preview = true
      
    },
    deleteDropFile() {
    //  this.form.picture.value = ''
      this.upload = true
      this.preview = false
    },
    cekData()
    {
       if(this.file === null)
        {
            // this.form.file = 'is-danger'
            // this.form.file = "Tidak Bisa Import"
           return false
        }

    },
    // clearError(form)
    // {
    //     console.log(form)
    //     form.type = ''
    //     form.message = ''
    // },
    postData()
    {
      var uri = this.$apiUrl + "import"
      var form = new FormData()

      console.log(this.isLoading)
      this.isLoading = true
      console.log(this.isLoading)
      

      if(this.cekData()=== false)
      {
          this.snackbar("Gagal...Silahkan input lagi", 'is-danger')
          this.file = null
          this.isLoading = false
           console.log(this.isLoading)
      }else{
        form.append("file_excel", this.file)
        this.$http.post(uri, form, this.config)
        .then(response => {
          //  this.$router.push( { name: 'BerandaBlog' } )
          this.isLoading = false
           console.log(this.isLoading)
          this.snackbarMsg = response.data.message
          this.snackbar("Data berhasil di Import!", 'is-success')
          console.log(response.data.message)
          // this.file = null
          
        })
        .catch(error => {
         // console.log(error.response.data.message)
         this.isLoading = false
          console.log(this.isLoading)
           this.errors = error;
          if (this.errors.message == "Request failed with status code 400") {
            this.snackbar("Edit gagal.Inputan salah...", 'is-danger')
          } else {
            this.snackbar("Terjadi kesalahan..Silahkan input lagi", 'is-danger')
          }
          // this.file = null
          
        })
      }
    },
    
    snackbar(snackbarMessage, type)
    {
      this.$buefy.toast.open({
        duration: 5000,
        message: snackbarMessage,
        type: type,
        position: 'is-top',
        actionText: 'OK',
        queue: false,
      })
    },


  },
  watch:{
     picture: function(o) {
      var reader = new FileReader();
      reader.onload = e => this.$emit("load", e.target.result);
      reader.readAsText(o[0]);
      alert();
    }

  },
  mounted(){
    if(this.$session.exists()){
      this.config = {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token')
        }
      }
    }
  }

}
</script>
<style scoped>
  img.preview {
    width: 200px;
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
  }
</style>

